import { Nullish } from '@snap-types/types/nullish';

export function getTermText(
  customerId: Nullish<string>,
  termsNetDays?: Nullish<number>,
) {
  if (!customerId) {
    return 'TBD';
  }

  if (!termsNetDays) {
    return 'Prepaid';
  }

  return `NET ${termsNetDays}`;
}
